import styled from 'styled-components';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FlexView, Text } from '@cuemath/comps';
import { store } from 'redux-rest-reducer';

import { CUEMATH_URL } from 'constants/api';
import { getParams } from 'utils';
import { post as executePaymentAction } from 'actions/execute-payment';
import BallLoader from 'comps/ball-loader';

const FullFlexView = styled(FlexView)`
  height: 40vh;
  width: auto;
`;

const FailureLink = styled.a`
  display: block;
  background: red;
  border-radius: 5px;
  padding: 8px;
  text-decoration: none;
`;

const SuccessLink = styled.a`
  display: block;
  background: green;
  border-radius: 5px;
  padding: 8px;
  text-decoration: none;
`;

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class PaymentStatusWrapper extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      executePaymentAction: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      message: null,
      executePaymentPost: store.post(),
      loading: true,
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    var params = getParams(window.location.href);
    const {
      executePaymentPost: { id },
    } = this.state;
    actions.executePaymentAction(id, params, params.token);
  }

  static getDerivedStateFromProps({ executePayment }, { executePaymentPost }) {
    let newState = {};
    const newexecutePaymentPost = store.post(executePayment, executePaymentPost.id);
    if (newexecutePaymentPost.resolved && newexecutePaymentPost.resolved.isCreated) {
      newState['isCreated'] = true;
      newState['loading'] = false;
    } else if (
      newexecutePaymentPost.resolved &&
      newexecutePaymentPost.resolved.isCreatingFailed
    ) {
      newState['isCreationFailed'] = true;
      newState['loading'] = false;
    }
    return newState;
  }

  render() {
    const { isCreationFailed, isCreated, loading } = this.state;
    var params = getParams(window.location.href);
    if (loading) {
      return (
        <FullFlexView justifyContent="center" alignItems="center">
          <LoadingWrapper>
            <BallLoader />
          </LoadingWrapper>
        </FullFlexView>
      );
    }
    if (isCreationFailed) {
      return (
        <FullFlexView justifyContent="center" alignItems="center">
          <FailureLink href={CUEMATH_URL}>
            <Text align="center" color="white" weight="bold">
              Payment Failed, Please try again later
            </Text>
          </FailureLink>
        </FullFlexView>
      );
    }
    if (isCreated && params.cancelled === 'True') {
      return (
        <FullFlexView justifyContent="center" alignItems="center">
          <FailureLink href={CUEMATH_URL}>
            <Text align="center" color="white" weight="bold">
              Payment Cancelled
            </Text>
          </FailureLink>
        </FullFlexView>
      );
    }
    if (isCreated) {
      return (
        <FullFlexView justifyContent="center" alignItems="center">
          <SuccessLink href={CUEMATH_URL}>
            <Text align="center" color="white" weight="bold">
              Payment Successful
            </Text>
          </SuccessLink>
        </FullFlexView>
      );
    }
  }
}

export default connect(
  ({ executePayment }) => ({ executePayment }),
  dispatch => ({
    actions: bindActionCreators(
      {
        executePaymentAction,
      },
      dispatch,
    ),
  }),
)(PaymentStatusWrapper);
